module.exports = __webpack_public_path__ + "static/media/fastGamesPlayed_50000_100000.5cb67e92.png";